import React from 'react';
import { get } from 'lodash';
import { Box, Text } from '@myob/myob-widgets';
import { ProductData } from 'hooks/useGetProduct/types';
import { useContentContext } from 'providers/contentProvider/ContentProvider';
import { getListPrice } from 'utils/pricingUtils';
import aiBasSparkleIcon from 'assets/svg/ai_bas_sparkle_icon.svg';
import style from './AddOnView.module.scss';

export type AddOnViewProps = {
  productData?: ProductData;
};

export const AddOnView: React.FC<AddOnViewProps> = ({ productData }) => {
  const { products } = useContentContext();
  const productItems = get(productData, 'items', []);
  const productItem = productItems[0];

  if (!productItem) {
    return null;
  }

  const price = getListPrice(productItem, productData?.region);
  const productName = products?.find(
    (product) => product.productId.toString() === productItem.productId
  )?.fullName ?? '';

  return (
    <Box
      className={style.addOnView}
      data-testid='add-on-view'
      display='flex'
      flexDirection='column'
    >
      <Box
        className={style.productRow}
        display='flex'
        justifyContent='space-between'
        alignItems='flex-start'
      >
        <Box className={style.productNameGroup} display='flex' alignItems='flex-start'>
          <img
            alt=''
            aria-hidden='true'
            className={style.sparkleIcon}
            data-testid='ai-bas-sparkle-icon'
            src={aiBasSparkleIcon}
          />
          <Text
            className={style.productName}
            as='span'
            marginBottom='clear'
            tone='neutralStrongest'
          >
            {productName}
          </Text>
        </Box>
        <Box className={style.priceGroup} display='flex' alignItems='end'>
          <Text
            className={style.priceAmount}
            as='span'
            marginBottom='clear'
            tone='neutralStrongest'
          >
            ${price}
          </Text>
          <Text
            className={style.priceSchedule}
            as='span'
            marginBottom='clear'
            tone='neutralStrongest'
          >
            /month
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
